(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-faq"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lp-compression-faq'))customElements.define('lp-compression-faq',class extends HTMLElement{
connectedCallback(){this.controller=new AbortController();const opts={signal:this.controller.signal};const items=[...this.querySelectorAll('details')];items.forEach(item=>item.addEventListener('toggle',()=>{if(item.open&&this.dataset.single==='true')items.forEach(other=>{if(other!==item)other.open=false})},opts));this.addEventListener('shopify:block:select',e=>{const item=items.find(x=>x.dataset.block===e.detail.blockId);if(item)item.open=true},opts)}
disconnectedCallback(){this.controller?.abort()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-mission"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lp-mission-carousel')) {
 customElements.define('lp-mission-carousel', class extends HTMLElement {
  connectedCallback() {
   this.controller = new AbortController();
   const opts = {signal:this.controller.signal};
   this.viewport = this.querySelector('.lp-carousel__viewport');
   this.originals = [...this.viewport.children];
   this.count = this.originals.length;
   if (!this.count) return;
   this.loop = this.dataset.loop === 'true' && this.count > 1;
   if (this.loop) {
    const clone = el => { const c=el.cloneNode(true); c.removeAttribute('data-shopify-editor-block'); c.removeAttribute('data-slide-id'); c.setAttribute('aria-hidden','true'); c.dataset.clone='true'; return c; };
    this.viewport.prepend(...this.originals.map(clone));
    this.viewport.append(...this.originals.map(clone));
   }
   this.slides=[...this.viewport.children];
   this.index=(this.loop?this.count:0)+Math.min(this.count-1,Math.max(0,(Number(this.dataset.start)||1)-1));
   this.go = (index,smooth=true) => { this.index=index; const el=this.slides[index]; if(!el)return; const r=el.getBoundingClientRect(),v=this.viewport.getBoundingClientRect(); this.viewport.scrollTo({left:this.viewport.scrollLeft+r.left-v.left-(v.width-r.width)/2,behavior:smooth&&!matchMedia('(prefers-reduced-motion: reduce)').matches?'smooth':'instant'}); };
   const move=delta=>this.go(this.loop?Math.max(0,Math.min(this.slides.length-1,this.index+delta)):Math.max(0,Math.min(this.count-1,this.index+delta)));
   this.querySelector('[data-prev]')?.addEventListener('click',()=>move(-1),opts);
   this.querySelector('[data-next]')?.addEventListener('click',()=>move(1),opts);
   this.viewport.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}},opts);
   const settle=()=>{const v=this.viewport.getBoundingClientRect();let best=Infinity,index=0;this.slides.forEach((el,i)=>{const r=el.getBoundingClientRect(),d=Math.abs(r.left+r.width/2-v.left-v.width/2);if(d<best){best=d;index=i;}});this.index=index;if(this.loop&&(index<this.count||index>=this.count*2))this.go(this.count+index%this.count,false);this.querySelector('[data-prev]')?.toggleAttribute('disabled',!this.loop&&this.index===0);this.querySelector('[data-next]')?.toggleAttribute('disabled',!this.loop&&this.index===this.count-1);};
   this.viewport.addEventListener('scroll',()=>{clearTimeout(this.timer);this.timer=setTimeout(settle,160);},opts);
   this.addEventListener('shopify:block:select',e=>{const index=this.slides.findIndex(el=>el.dataset.slideId===e.detail.blockId);if(index>=0)this.go(index,false);},opts);
   this.observer=new ResizeObserver(()=>{const width=this.originals[0].getBoundingClientRect().width;this.viewport.style.paddingInline=Math.max(0,(this.viewport.clientWidth-width)/2)+'px';this.go(this.index,false);});this.observer.observe(this.viewport);
   requestAnimationFrame(()=>{this.go(this.index,false);settle();});
  }
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();clearTimeout(this.timer);this.querySelectorAll('[data-clone]').forEach(el=>el.remove());}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-products"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('bf-product-carousel'))customElements.define('bf-product-carousel',class extends HTMLElement{connectedCallback(){this.controller?.abort();this.controller=new AbortController();const opts={signal:this.controller.signal},track=this.querySelector('.bf-product-track'),cards=[...track.children],counter=this.querySelector('[data-counter]');let index=0;const update=()=>{if(counter)counter.textContent=cards.length?`${index+1}/${cards.length}`:'0/0';this.querySelector('[data-prev]').disabled=index===0;this.querySelector('[data-next]').disabled=index>=cards.length-1;};const go=i=>{index=Math.max(0,Math.min(cards.length-1,i));if(cards[index])track.scrollTo({left:cards[index].offsetLeft-track.firstElementChild.offsetLeft,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});update();};this.querySelector('[data-prev]').addEventListener('click',()=>go(index-1),opts);this.querySelector('[data-next]').addEventListener('click',()=>go(index+1),opts);track.addEventListener('keydown',e=>{if(['ArrowRight','ArrowLeft','Home','End'].includes(e.key)){e.preventDefault();go(e.key==='Home'?0:e.key==='End'?cards.length-1:index+(e.key==='ArrowRight'?1:-1));}},opts);track.addEventListener('scroll',()=>{index=cards.reduce((best,c,i)=>Math.abs(c.offsetLeft-cards[0].offsetLeft-track.scrollLeft)<Math.abs(cards[best].offsetLeft-cards[0].offsetLeft-track.scrollLeft)?i:best,0);update();},opts);this.addEventListener('shopify:block:select',e=>{const i=cards.findIndex(c=>c.getAttribute('data-shopify-editor-block')?.includes(e.detail.blockId));if(i>=0)go(i);},opts);update();}disconnectedCallback(){this.controller?.abort();}});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-reasons"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lp-reasons-carousel')) {
 customElements.define('lp-reasons-carousel',class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort();this.observer?.disconnect();
   this.controller=new AbortController();const opts={signal:this.controller.signal};
   this.viewport=this.querySelector('.reasons-track');this.slides=[...this.viewport.children];this.media=matchMedia('(min-width:1024px)');this.start=()=>Math.max(0,(parseInt(this.media.matches?this.dataset.startDesktop:this.dataset.startMobile,10)||1)-1);this.index=this.start();
   this.loop=this.dataset.loop==='true';
   this.go=(index,smooth=true)=>{if(!this.slides.length)return;this.index=Math.max(0,Math.min(this.slides.length-1,index));const el=this.slides[this.index],r=el.getBoundingClientRect(),v=this.viewport.getBoundingClientRect();this.viewport.scrollTo({left:this.viewport.scrollLeft+r.left-v.left-(matchMedia("(min-width:1024px)").matches?(v.width-r.width)/2:0),behavior:smooth&&!matchMedia('(prefers-reduced-motion: reduce)').matches?'smooth':'instant'});this.update();};
   this.update=()=>{const counter=this.querySelector('[data-counter]');if(counter)counter.textContent=this.slides.length?(this.index+1)+'/'+this.slides.length:'0/0';this.querySelector('[data-prev]')?.toggleAttribute('disabled',this.slides.length<2||!this.loop&&this.index===0);this.querySelector('[data-next]')?.toggleAttribute('disabled',this.slides.length<2||!this.loop&&this.index===this.slides.length-1);};
   const move=delta=>{let index=this.index+delta;if(this.loop)index=(index+this.slides.length)%this.slides.length;this.go(index);};
   this.querySelector('[data-prev]')?.addEventListener('click',()=>move(-1),opts);this.querySelector('[data-next]')?.addEventListener('click',()=>move(1),opts);
   this.viewport.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}else if(e.key==='Home'||e.key==='End'){e.preventDefault();this.go(e.key==='Home'?0:this.slides.length-1);}},opts);
   this.viewport.addEventListener('scroll',()=>{clearTimeout(this.timer);this.timer=setTimeout(()=>{const left=this.viewport.getBoundingClientRect().left;let best=Infinity;this.slides.forEach((el,i)=>{const r=el.getBoundingClientRect();const d=Math.abs(r.left-left+(matchMedia("(min-width:1024px)").matches?(r.width-this.viewport.clientWidth)/2:0));if(d<best){best=d;this.index=i;}});this.update();},120);},opts);
   this.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(el=>el.dataset.slideId===e.detail.blockId);if(i>=0)this.go(i,false);},opts);
   this.media.addEventListener('change',()=>this.go(this.start(),false),opts);this.observer=new ResizeObserver(()=>this.go(this.index,false));this.observer.observe(this.viewport);this.update();
  }
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();clearTimeout(this.timer);}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-lp-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lp-image-carousel')) {
 customElements.define('lp-image-carousel', class extends HTMLElement {
  connectedCallback() {
   this.controller = new AbortController();
   const opts = {signal:this.controller.signal};
   this.viewport = this.querySelector('.lp-carousel__viewport');
   this.originals = [...this.viewport.children];
   this.count = this.originals.length;
   if (!this.count) return;
   this.loop = this.dataset.loop === 'true' && this.count > 1;
   if (this.loop) {
    const clone = el => { const c=el.cloneNode(true); c.removeAttribute('data-shopify-editor-block'); c.removeAttribute('data-slide-id'); c.setAttribute('aria-hidden','true'); c.dataset.clone='true'; return c; };
    this.viewport.prepend(...this.originals.map(clone));
    this.viewport.append(...this.originals.map(clone));
   }
   this.slides=[...this.viewport.children];
   this.index=(this.loop?this.count:0)+Math.min(this.count-1,Math.max(0,(Number(this.dataset.start)||1)-1));
   this.go = (index,smooth=true) => { this.index=index; const el=this.slides[index]; if(!el)return; const r=el.getBoundingClientRect(),v=this.viewport.getBoundingClientRect(); this.viewport.scrollTo({left:this.viewport.scrollLeft+r.left-v.left-(v.width-r.width)/2,behavior:smooth&&!matchMedia('(prefers-reduced-motion: reduce)').matches?'smooth':'instant'}); };
   const move=delta=>this.go(this.loop?Math.max(0,Math.min(this.slides.length-1,this.index+delta)):Math.max(0,Math.min(this.count-1,this.index+delta)));
   this.querySelector('[data-prev]')?.addEventListener('click',()=>move(-1),opts);
   this.querySelector('[data-next]')?.addEventListener('click',()=>move(1),opts);
   this.viewport.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}},opts);
   const settle=()=>{const v=this.viewport.getBoundingClientRect();let best=Infinity,index=0;this.slides.forEach((el,i)=>{const r=el.getBoundingClientRect(),d=Math.abs(r.left+r.width/2-v.left-v.width/2);if(d<best){best=d;index=i;}});this.index=index;if(this.loop&&(index<this.count||index>=this.count*2))this.go(this.count+index%this.count,false);this.querySelector('[data-prev]')?.toggleAttribute('disabled',!this.loop&&this.index===0);this.querySelector('[data-next]')?.toggleAttribute('disabled',!this.loop&&this.index===this.count-1);};
   this.viewport.addEventListener('scroll',()=>{clearTimeout(this.timer);this.timer=setTimeout(settle,160);},opts);
   this.addEventListener('shopify:block:select',e=>{const index=this.slides.findIndex(el=>el.dataset.slideId===e.detail.blockId);if(index>=0)this.go(index,false);},opts);
   this.observer=new ResizeObserver(()=>{const width=this.originals[0].getBoundingClientRect().width;this.viewport.style.paddingInline=Math.max(0,(this.viewport.clientWidth-width)/2)+'px';this.go(this.index,false);});this.observer.observe(this.viewport);
   requestAnimationFrame(()=>{this.go(this.index,false);settle();});
  }
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();clearTimeout(this.timer);this.querySelectorAll('[data-clone]').forEach(el=>el.remove());}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-lp-reason"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lp-deferred-image')) {
  customElements.define('lp-deferred-image', class extends HTMLElement {
    connectedCallback() {
      const template = this.querySelector('template');
      if (!template) return;
      const load = () => {
        if (!template.isConnected) return;
        this.appendChild(template.content.cloneNode(true));
        template.remove();
        this.observer?.disconnect();
      };
      if (!('IntersectionObserver' in window) || window.Shopify?.designMode) {
        load();
        return;
      }
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) load();
      }, { rootMargin: '400px 0px' });
      this.observer.observe(this);
    }
    disconnectedCallback() { this.observer?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-lp-settings"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lp-header-settings')) {
  customElements.define('lp-header-settings', class extends HTMLElement {
    connectedCallback() {
      this.main = this.closest('main');
      const announcement = document.querySelector('.section-announcement-bar');
      const update = () => this.main?.style.setProperty('--lp-announcement-height', (announcement?.getBoundingClientRect().height || 0) + 'px');
      update();
      if (announcement) {
        this.observer = new ResizeObserver(update);
        this.observer.observe(announcement);
      }
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.main?.style.removeProperty('--lp-announcement-height');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-lp-sticky-cta"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lp-mobile-sticky')) {
 customElements.define('lp-mobile-sticky', class extends HTMLElement {
  connectedCallback() {
   this.bar=this.querySelector('.lp-sticky__bar');this.spacer=this.querySelector('.lp-sticky__spacer');
   this.controller=new AbortController();const options={signal:this.controller.signal,passive:true};
   this.update=()=>{
    this.frame=0;
    const mobile=matchMedia('(max-width:1023px)').matches;
    const reserved=this.spacer.getBoundingClientRect().height;
    const available=Math.max(0,document.documentElement.scrollHeight-reserved-innerHeight);
    const threshold=this.dataset.mode==='pixels'?Math.max(0,Number(this.dataset.pixels)||0):available*Math.max(0,Number(this.dataset.percent)||0)/100;
    const visible=mobile&&scrollY>=threshold;
    this.bar.hidden=!visible;
    this.spacer.style.height=visible?this.bar.getBoundingClientRect().height+'px':'0px';
   };
   this.schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(this.update);};
   window.addEventListener('scroll',this.schedule,options);window.addEventListener('resize',this.schedule,options);
   this.observer=new ResizeObserver(this.schedule);this.observer.observe(document.body);this.observer.observe(this.bar);
   this.update();
  }
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();cancelAnimationFrame(this.frame);}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-realtree-features"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', event => {
    const cta = event.target.closest('.ds-realtree-features__cta');
    if (!cta || cta.getAttribute('href') !== '#realtree-order') return;
    const pdp = document.getElementById('realtree-order') || document.querySelector('.ds-v2-pdp__purchase');
    if (!pdp) return;
    event.preventDefault();
    pdp.scrollIntoView({ behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-realtree-pdp"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ds-realtree-countdown')) {
    customElements.define('ds-realtree-countdown', class extends HTMLElement {
      connectedCallback() {
        if (this.intervalId !== undefined) return;
        const pad = value => String(value).padStart(2, '0');
        this.tick = () => {
          const now = new Date();
          const end = new Date(now);
          end.setHours(24, 0, 0, 0);
          const seconds = Math.max(0, Math.floor((end - now) / 1000));
          this.textContent = pad(Math.floor(seconds / 3600)) + ':' + pad(Math.floor((seconds % 3600) / 60)) + ':' + pad(seconds % 60);
        };
        this.tick();
        this.intervalId = window.setInterval(this.tick, 1000);
        document.addEventListener('visibilitychange', this.tick);
      }
      disconnectedCallback() {
        window.clearInterval(this.intervalId);
        document.removeEventListener('visibilitychange', this.tick);
        this.intervalId = undefined;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-realtree-values"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ds-realtree-values')) {
    customElements.define('ds-realtree-values', class extends HTMLElement {
      connectedCallback() {
        if (this.controller) return;
        this.viewport = this.querySelector('.ds-realtree-values__viewport');
        this.track = this.querySelector('.ds-realtree-values__track');
        this.group = this.querySelector('.ds-realtree-values__group');
        if (!this.viewport || !this.group || !this.group.children.length) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.mobile = matchMedia('(max-width: 767px)');
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
        this.hovered = false;
        this.focused = false;
        this.dragging = false;
        this.editorSelected = false;
        this.viewport.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.sync(); } }, { signal });
        this.viewport.addEventListener('pointerleave', () => { this.hovered = false; this.sync(); }, { signal });
        this.viewport.addEventListener('pointerdown', () => { this.dragging = true; this.sync(); }, { signal });
        document.addEventListener('pointerup', () => { this.dragging = false; this.sync(); }, { signal });
        document.addEventListener('pointercancel', () => { this.dragging = false; this.sync(); }, { signal });
        this.viewport.addEventListener('focusin', () => { this.focused = true; this.sync(); }, { signal });
        this.viewport.addEventListener('focusout', () => { this.focused = false; this.sync(); }, { signal });
        document.addEventListener('visibilitychange', () => this.sync(), { signal });
        this.mobile.addEventListener('change', () => this.rebuild(), { signal });
        this.reducedMotion.addEventListener('change', () => this.rebuild(), { signal });
        document.addEventListener('shopify:block:select', event => {
          const item = Array.from(this.group.children).find(node => node.dataset.valueId === event.detail.blockId);
          if (!item) return;
          this.editorSelected = true;
          this.animation?.cancel();
          this.animation = null;
          this.viewport.scrollLeft = this.mobile.matches ? item.offsetLeft : 0;
        }, { signal });
        document.addEventListener('shopify:block:deselect', () => { this.editorSelected = false; this.rebuild(); }, { signal });
        this.resizeObserver = new ResizeObserver(() => this.rebuild());
        this.resizeObserver.observe(this.viewport);
        this.resizeObserver.observe(this.group);
        this.rebuild();
      }
      rebuild() {
        this.animation?.cancel();
        this.animation = null;
        this.track.querySelectorAll('[data-clone]').forEach(node => node.remove());
        this.viewport.scrollLeft = 0;
        if (!this.mobile.matches || this.reducedMotion.matches || this.dataset.autoplay !== 'true' || this.editorSelected) return;
        const distance = this.group.getBoundingClientRect().width;
        if (!distance) return;
        const copies = Math.ceil(this.viewport.clientWidth / distance) + 1;
        for (let i = 0; i < copies; i++) {
          const clone = this.group.cloneNode(true);
          clone.dataset.clone = '';
          clone.setAttribute('aria-hidden', 'true');
          clone.setAttribute('inert', '');
          clone.querySelectorAll('[id]').forEach(node => node.removeAttribute('id'));
          clone.querySelectorAll('[data-shopify-editor-block]').forEach(node => node.removeAttribute('data-shopify-editor-block'));
          this.track.append(clone);
        }
        const duration = Math.max(1000, Number(this.dataset.speed) || 4000) * this.group.children.length;
        this.animation = this.track.animate([
          { transform: 'translate3d(0, 0, 0)' },
          { transform: `translate3d(-${distance}px, 0, 0)` }
        ], { duration, iterations: Infinity, easing: 'linear' });
        this.sync();
      }
      sync() {
        if (!this.animation) return;
        if (document.hidden || this.hovered || this.focused || this.dragging || this.editorSelected) this.animation.pause();
        else this.animation.play();
      }
      disconnectedCallback() {
        this.animation?.cancel();
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        this.track?.querySelectorAll('[data-clone]').forEach(node => node.remove());
        this.controller = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-usa-crew-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('usa-crew-carousel')) {
 customElements.define('usa-crew-carousel', class extends HTMLElement {
  connectedCallback() {
   this.controller = new AbortController();
   const opts = {signal:this.controller.signal};
   this.viewport = this.querySelector('.lp-carousel__viewport');
   this.originals = [...this.viewport.children];
   this.count = this.originals.length;
   if (!this.count) return;
   this.loop = this.dataset.loop === 'true' && this.count > 1;
   if (this.loop) {
    const clone = el => { const c=el.cloneNode(true); c.removeAttribute('data-shopify-editor-block'); c.removeAttribute('data-slide-id'); c.setAttribute('aria-hidden','true'); c.dataset.clone='true'; return c; };
    this.viewport.prepend(...this.originals.map(clone));
    this.viewport.append(...this.originals.map(clone));
   }
   this.slides=[...this.viewport.children];
   this.index=(this.loop?this.count:0)+Math.min(this.count-1,Math.max(0,(Number(this.dataset.start)||1)-1));
   this.go = (index,smooth=true) => { this.index=index; const el=this.slides[index]; if(!el)return; const r=el.getBoundingClientRect(),v=this.viewport.getBoundingClientRect(); this.viewport.scrollTo({left:this.viewport.scrollLeft+r.left-v.left-(v.width-r.width)/2,behavior:smooth&&!matchMedia('(prefers-reduced-motion: reduce)').matches?'smooth':'instant'}); };
   const move=delta=>this.go(this.loop?Math.max(0,Math.min(this.slides.length-1,this.index+delta)):Math.max(0,Math.min(this.count-1,this.index+delta)));
   this.querySelector('[data-prev]')?.addEventListener('click',()=>move(-1),opts);
   this.querySelector('[data-next]')?.addEventListener('click',()=>move(1),opts);
   this.viewport.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}},opts);
   const settle=()=>{const v=this.viewport.getBoundingClientRect();let best=Infinity,index=0;this.slides.forEach((el,i)=>{const r=el.getBoundingClientRect(),d=Math.abs(r.left+r.width/2-v.left-v.width/2);if(d<best){best=d;index=i;}});this.index=index;if(this.loop&&(index<this.count||index>=this.count*2))this.go(this.count+index%this.count,false);this.querySelector('[data-prev]')?.toggleAttribute('disabled',!this.loop&&this.index===0);this.querySelector('[data-next]')?.toggleAttribute('disabled',!this.loop&&this.index===this.count-1);};
   this.viewport.addEventListener('scroll',()=>{clearTimeout(this.timer);this.timer=setTimeout(settle,160);},opts);
   this.addEventListener('shopify:block:select',e=>{const index=this.slides.findIndex(el=>el.dataset.slideId===e.detail.blockId);if(index>=0)this.go(index,false);},opts);
   this.observer=new ResizeObserver(()=>{const width=this.originals[0].getBoundingClientRect().width;this.viewport.style.paddingInline=Math.max(0,(this.viewport.clientWidth-width)/2)+'px';this.go(this.index,false);});this.observer.observe(this.viewport);
   requestAnimationFrame(()=>{this.go(this.index,false);settle();});
  }
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();clearTimeout(this.timer);this.querySelectorAll('[data-clone]').forEach(el=>el.remove());}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-usa-crew-features"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', event => {
    const cta = event.target.closest('.ds-usa-crew-features__cta');
    if (!cta || cta.getAttribute('href') !== '#realtree-order') return;
    const pdp = document.getElementById('realtree-order') || document.querySelector('.ds-v2-pdp__purchase');
    if (!pdp) return;
    event.preventDefault();
    pdp.scrollIntoView({ behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block:'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-usa-crew-hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', event => {
    const cta = event.target.closest('.usa-crew-hero__cta');
    if (!cta || cta.getAttribute('href') !== '#realtree-order') return;
    const pdp = document.getElementById('realtree-order') || document.querySelector('.ds-v2-pdp__purchase');
    if (!pdp) return;
    event.preventDefault();
    pdp.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ds-usa-crew-pdp"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('ds-realtree-countdown')) {
    customElements.define('ds-realtree-countdown', class extends HTMLElement {
      connectedCallback() {
        if (this.intervalId !== undefined) return;
        const pad = value => String(value).padStart(2, '0');
        this.tick = () => {
          const now = new Date();
          const end = new Date(now);
          end.setHours(24, 0, 0, 0);
          const seconds = Math.max(0, Math.floor((end - now) / 1000));
          this.textContent = pad(Math.floor(seconds / 3600)) + ':' + pad(Math.floor((seconds % 3600) / 60)) + ':' + pad(seconds % 60);
        };
        this.tick();
        this.intervalId = window.setInterval(this.tick, 1000);
        document.addEventListener('visibilitychange', this.tick);
      }
      disconnectedCallback() {
        window.clearInterval(this.intervalId);
        document.removeEventListener('visibilitychange', this.tick);
        this.intervalId = undefined;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-5r-experts"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lp-health-experts'))customElements.define('lp-health-experts',class extends HTMLElement{
connectedCallback(){this.controller=new AbortController();const opts={signal:this.controller.signal};this.v=this.querySelector('.lp-experts__viewport');this.cards=[...this.v.children];this.media=matchMedia('(min-width:1024px)');this.start=()=>Math.max(0,(parseInt(this.media.matches?this.dataset.startDesktop:this.dataset.startMobile,10)||1)-1);this.index=this.start();this.update=()=>{this.querySelector('[data-counter]').textContent=this.cards.length?(this.index+1)+'/'+this.cards.length:'0/0';this.querySelector('[data-prev]').disabled=this.index===0;this.querySelector('[data-next]').disabled=this.index>=this.cards.length-1};this.go=(i,smooth=true)=>{this.index=Math.max(0,Math.min(this.cards.length-1,i));const card=this.cards[this.index];if(card){const r=card.getBoundingClientRect(),v=this.v.getBoundingClientRect();this.v.scrollTo({left:this.v.scrollLeft+r.left-v.left-(matchMedia("(min-width:1024px)").matches?(v.width-r.width)/2:0),behavior:!smooth||matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})}this.update()};this.querySelector('[data-prev]').addEventListener('click',()=>this.go(this.index-1),opts);this.querySelector('[data-next]').addEventListener('click',()=>this.go(this.index+1),opts);this.v.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.go(this.index+(e.key==='ArrowRight'?1:-1))}},opts);this.v.addEventListener('scroll',()=>{clearTimeout(this.timer);this.timer=setTimeout(()=>{const left=this.v.getBoundingClientRect().left;let closest=Infinity;this.cards.forEach((c,i)=>{const r=c.getBoundingClientRect();const distance=Math.abs(r.left-left+(matchMedia("(min-width:1024px)").matches?(r.width-this.v.clientWidth)/2:0));if(distance<closest){closest=distance;this.index=i}});this.update()},120)},opts);this.addEventListener('shopify:block:select',e=>{const i=this.cards.findIndex(c=>c.dataset.block===e.detail.blockId);if(i>=0)this.go(i)},opts);this.media.addEventListener('change',()=>this.go(this.start(),false),opts);this.observer=new ResizeObserver(()=>this.go(this.index,false));this.observer.observe(this.v);this.go(this.index,false);this.update()}
disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();clearTimeout(this.timer)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-5r-faq"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lp-compression-faq'))customElements.define('lp-compression-faq',class extends HTMLElement{
connectedCallback(){this.controller=new AbortController();const opts={signal:this.controller.signal};const items=[...this.querySelectorAll('details')];items.forEach(item=>item.addEventListener('toggle',()=>{if(item.open&&this.dataset.single==='true')items.forEach(other=>{if(other!==item)other.open=false})},opts));this.addEventListener('shopify:block:select',e=>{const item=items.find(x=>x.dataset.block===e.detail.blockId);if(item)item.open=true},opts)}
disconnectedCallback(){this.controller?.abort()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-5r-features"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('lp-alpaca-features'))customElements.define('lp-alpaca-features',class extends HTMLElement{
connectedCallback(){this.controller=new AbortController();const opts={signal:this.controller.signal};this.v=this.querySelector('.lp-features__viewport');this.cards=[...this.v.children];this.media=matchMedia('(min-width:1024px)');this.start=()=>Math.max(0,(parseInt(this.media.matches?this.dataset.startDesktop:this.dataset.startMobile,10)||1)-1);this.index=this.start();this.update=()=>{this.querySelector('[data-counter]').textContent=this.cards.length?(this.index+1)+'/'+this.cards.length:'0/0';this.querySelector('[data-prev]').disabled=this.index===0;this.querySelector('[data-next]').disabled=this.index>=this.cards.length-1};this.go=(i,smooth=true)=>{this.index=Math.max(0,Math.min(this.cards.length-1,i));const card=this.cards[this.index];if(card){const r=card.getBoundingClientRect(),v=this.v.getBoundingClientRect();this.v.scrollTo({left:this.v.scrollLeft+r.left-v.left-(matchMedia("(min-width:1024px)").matches?(v.width-r.width)/2:0),behavior:!smooth||matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})}this.update()};this.querySelector('[data-prev]').addEventListener('click',()=>this.go(this.index-1),opts);this.querySelector('[data-next]').addEventListener('click',()=>this.go(this.index+1),opts);this.v.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();this.go(this.index+(e.key==='ArrowRight'?1:-1))}},opts);this.v.addEventListener('scroll',()=>{clearTimeout(this.timer);this.timer=setTimeout(()=>{const left=this.v.getBoundingClientRect().left;let closest=Infinity;this.cards.forEach((c,i)=>{const r=c.getBoundingClientRect();const distance=Math.abs(r.left-left+(matchMedia("(min-width:1024px)").matches?(r.width-this.v.clientWidth)/2:0));if(distance<closest){closest=distance;this.index=i}});this.update()},120)},opts);this.addEventListener('shopify:block:select',e=>{const i=this.cards.findIndex(c=>c.dataset.block===e.detail.blockId);if(i>=0)this.go(i)},opts);this.media.addEventListener('change',()=>this.go(this.start(),false),opts);this.observer=new ResizeObserver(()=>this.go(this.index,false));this.observer.observe(this.v);this.go(this.index,false);this.update()}
disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();clearTimeout(this.timer)}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-5r-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lp-hero-video')) {
  customElements.define('lp-hero-video', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const opts = { signal: this.controller.signal };
      const video = this.querySelector('video');
      if (!video) return;
      this.video = video;
      const overlay = this.querySelector('[data-unmute]');
      const unmuteButton = this.querySelector('[data-unmute-button]');
      const touch = matchMedia('(hover: none), (pointer: coarse)');
      const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      let hovered = false;
      let blocked = false;
      const syncOverlay = () => {
        if (overlay) overlay.hidden = !video.muted && video.volume > 0;
      };
      const syncControls = () => {
        video.controls = this.dataset.controls === 'always' || touch.matches || hovered ||
          blocked || video.paused || this.contains(document.activeElement) ||
          document.fullscreenElement === video || !!video.webkitDisplayingFullscreen;
      };
      const play = () => {
        const result = video.play();
        result?.catch(() => { blocked = true; syncControls(); });
      };
      const unmute = () => {
        video.muted = false;
        if (video.volume === 0) video.volume = 1;
        syncOverlay();
        if (video.paused) play();
      };
      video.muted = true;
      syncOverlay();
      syncControls();
      this.addEventListener('pointerenter', () => { hovered = true; syncControls(); }, opts);
      this.addEventListener('pointerleave', () => { hovered = false; syncControls(); }, opts);
      this.addEventListener('focusin', syncControls, opts);
      this.addEventListener('focusout', () => queueMicrotask(syncControls), opts);
      video.addEventListener('volumechange', syncOverlay, opts);
      video.addEventListener('play', () => { blocked = false; syncControls(); }, opts);
      video.addEventListener('pause', syncControls, opts);
      video.addEventListener('ended', syncControls, opts);
      video.addEventListener('click', event => {
        if (this.dataset.clickUnmute !== 'true' || !video.muted) return;
        const bounds = video.getBoundingClientRect();
        if (event.clientY >= bounds.bottom - Math.min(64, bounds.height / 3)) return;
        unmute();
      }, opts);
      unmuteButton?.addEventListener('click', unmute, opts);
      touch.addEventListener('change', syncControls, opts);
      reducedMotion.addEventListener('change', () => {
        if (reducedMotion.matches) video.pause();
        syncControls();
      }, opts);
      document.addEventListener('fullscreenchange', syncControls, opts);
      if (this.dataset.autoplay === 'true' && !reducedMotion.matches) play();
    }
    disconnectedCallback() {
      this.controller?.abort();
      this.video?.pause();
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-5r-mission"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lp-mission-carousel')) {
 customElements.define('lp-mission-carousel', class extends HTMLElement {
  connectedCallback() {
   this.controller = new AbortController();
   const opts = {signal:this.controller.signal};
   this.viewport = this.querySelector('.lp-carousel__viewport');
   this.originals = [...this.viewport.children];
   this.count = this.originals.length;
   if (!this.count) return;
   this.loop = this.dataset.loop === 'true' && this.count > 1;
   if (this.loop) {
    const clone = el => { const c=el.cloneNode(true); c.removeAttribute('data-shopify-editor-block'); c.removeAttribute('data-slide-id'); c.setAttribute('aria-hidden','true'); c.dataset.clone='true'; return c; };
    this.viewport.prepend(...this.originals.map(clone));
    this.viewport.append(...this.originals.map(clone));
   }
   this.slides=[...this.viewport.children];
   this.index=(this.loop?this.count:0)+Math.min(this.count-1,Math.max(0,(Number(this.dataset.start)||1)-1));
   this.go = (index,smooth=true) => { this.index=index; const el=this.slides[index]; if(!el)return; const r=el.getBoundingClientRect(),v=this.viewport.getBoundingClientRect(); this.viewport.scrollTo({left:this.viewport.scrollLeft+r.left-v.left-(v.width-r.width)/2,behavior:smooth&&!matchMedia('(prefers-reduced-motion: reduce)').matches?'smooth':'instant'}); };
   const move=delta=>this.go(this.loop?Math.max(0,Math.min(this.slides.length-1,this.index+delta)):Math.max(0,Math.min(this.count-1,this.index+delta)));
   this.querySelector('[data-prev]')?.addEventListener('click',()=>move(-1),opts);
   this.querySelector('[data-next]')?.addEventListener('click',()=>move(1),opts);
   this.viewport.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}},opts);
   const settle=()=>{const v=this.viewport.getBoundingClientRect();let best=Infinity,index=0;this.slides.forEach((el,i)=>{const r=el.getBoundingClientRect(),d=Math.abs(r.left+r.width/2-v.left-v.width/2);if(d<best){best=d;index=i;}});this.index=index;if(this.loop&&(index<this.count||index>=this.count*2))this.go(this.count+index%this.count,false);this.querySelector('[data-prev]')?.toggleAttribute('disabled',!this.loop&&this.index===0);this.querySelector('[data-next]')?.toggleAttribute('disabled',!this.loop&&this.index===this.count-1);};
   this.viewport.addEventListener('scroll',()=>{clearTimeout(this.timer);this.timer=setTimeout(settle,160);},opts);
   this.addEventListener('shopify:block:select',e=>{const index=this.slides.findIndex(el=>el.dataset.slideId===e.detail.blockId);if(index>=0)this.go(index,false);},opts);
   this.observer=new ResizeObserver(()=>{const width=this.originals[0].getBoundingClientRect().width;this.viewport.style.paddingInline=Math.max(0,(this.viewport.clientWidth-width)/2)+'px';this.go(this.index,false);});this.observer.observe(this.viewport);
   requestAnimationFrame(()=>{this.go(this.index,false);settle();});
  }
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();clearTimeout(this.timer);this.querySelectorAll('[data-clone]').forEach(el=>el.remove());}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-5r-reasons-carousel"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lp-reasons-carousel')) {
 customElements.define('lp-reasons-carousel',class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort();this.observer?.disconnect();
   this.controller=new AbortController();const opts={signal:this.controller.signal};
   this.viewport=this.querySelector('.reasons-track');this.slides=[...this.viewport.children];this.media=matchMedia('(min-width:1024px)');this.start=()=>Math.max(0,(parseInt(this.media.matches?this.dataset.startDesktop:this.dataset.startMobile,10)||1)-1);this.index=this.start();
   this.loop=this.dataset.loop==='true';
   this.go=(index,smooth=true)=>{if(!this.slides.length)return;this.index=Math.max(0,Math.min(this.slides.length-1,index));const el=this.slides[this.index],r=el.getBoundingClientRect(),v=this.viewport.getBoundingClientRect();this.viewport.scrollTo({left:this.viewport.scrollLeft+r.left-v.left-(matchMedia("(min-width:1024px)").matches?(v.width-r.width)/2:0),behavior:smooth&&!matchMedia('(prefers-reduced-motion: reduce)').matches?'smooth':'instant'});this.update();};
   this.update=()=>{const counter=this.querySelector('[data-counter]');if(counter)counter.textContent=this.slides.length?(this.index+1)+'/'+this.slides.length:'0/0';this.querySelector('[data-prev]')?.toggleAttribute('disabled',this.slides.length<2||!this.loop&&this.index===0);this.querySelector('[data-next]')?.toggleAttribute('disabled',this.slides.length<2||!this.loop&&this.index===this.slides.length-1);};
   const move=delta=>{let index=this.index+delta;if(this.loop)index=(index+this.slides.length)%this.slides.length;this.go(index);};
   this.querySelector('[data-prev]')?.addEventListener('click',()=>move(-1),opts);this.querySelector('[data-next]')?.addEventListener('click',()=>move(1),opts);
   this.viewport.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}else if(e.key==='Home'||e.key==='End'){e.preventDefault();this.go(e.key==='Home'?0:this.slides.length-1);}},opts);
   this.viewport.addEventListener('scroll',()=>{clearTimeout(this.timer);this.timer=setTimeout(()=>{const left=this.viewport.getBoundingClientRect().left;let best=Infinity;this.slides.forEach((el,i)=>{const r=el.getBoundingClientRect();const d=Math.abs(r.left-left+(matchMedia("(min-width:1024px)").matches?(r.width-this.viewport.clientWidth)/2:0));if(d<best){best=d;this.index=i;}});this.update();},120);},opts);
   this.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(el=>el.dataset.slideId===e.detail.blockId);if(i>=0)this.go(i,false);},opts);
   this.media.addEventListener('change',()=>this.go(this.start(),false),opts);this.observer=new ResizeObserver(()=>this.go(this.index,false));this.observer.observe(this.viewport);this.update();
  }
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();clearTimeout(this.timer);}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-5r-sticky-cta"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('lp-mobile-sticky')) {
 customElements.define('lp-mobile-sticky', class extends HTMLElement {
  connectedCallback() {
   this.bar=this.querySelector('.lp-sticky__bar');this.spacer=this.querySelector('.lp-sticky__spacer');
   this.controller=new AbortController();const options={signal:this.controller.signal,passive:true};
   this.update=()=>{
    this.frame=0;
    const mobile=matchMedia('(max-width:1023px)').matches;
    const reserved=this.spacer.getBoundingClientRect().height;
    const available=Math.max(0,document.documentElement.scrollHeight-reserved-innerHeight);
    const threshold=this.dataset.mode==='pixels'?Math.max(0,Number(this.dataset.pixels)||0):available*Math.max(0,Number(this.dataset.percent)||0)/100;
    const visible=mobile&&scrollY>=threshold;
    this.bar.hidden=!visible;
    this.spacer.style.height=visible?this.bar.getBoundingClientRect().height+'px':'0px';
   };
   this.schedule=()=>{if(!this.frame)this.frame=requestAnimationFrame(this.update);};
   window.addEventListener('scroll',this.schedule,options);window.addEventListener('resize',this.schedule,options);
   this.observer=new ResizeObserver(this.schedule);this.observer.observe(document.body);this.observer.observe(this.bar);
   this.update();
  }
  disconnectedCallback(){this.controller?.abort();this.observer?.disconnect();cancelAnimationFrame(this.frame);}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-knife-announcement"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mkc-announcement')) {
 class MkcAnnouncement extends HTMLElement {
  connectedCallback() {
   this.timer = this.querySelector('[role="timer"]');
   if (!this.timer) return;
   this.formatter = new Intl.DateTimeFormat('en-US', { timeZone:this.dataset.timezone || 'America/Chicago', year:'numeric', month:'2-digit', day:'2-digit', hour:'2-digit', minute:'2-digit', second:'2-digit', hourCycle:'h23' });
   this.update();
   this.interval = setInterval(() => this.update(), 1000);
  }
  disconnectedCallback() { clearInterval(this.interval); }
  parts(ms) {
   return Object.fromEntries(this.formatter.formatToParts(new Date(ms)).filter(p => p.type !== 'literal').map(p => [p.type, Number(p.value)]));
  }
  boundary(now) {
   const p = this.parts(now);
   const hour = Number(this.dataset.resetHour) || 0;
   const minute = Number(this.dataset.resetMinute) || 0;
   const resolve = day => {
    const wall = Date.UTC(p.year, p.month - 1, day, hour, minute);
    let target = wall;
    const seen = new Set();
    for (let i = 0; i < 6; i++) {
     seen.add(target);
     const z = this.parts(target);
     const delta = wall - Date.UTC(z.year,z.month - 1,z.day,z.hour,z.minute,z.second);
     if (!delta) return target;
     target += delta;
     if (seen.has(target)) return Math.max(target,...seen);
    }
    return target;
   };
   const today = resolve(p.day);
   return today > now ? today : resolve(p.day + 1);
  }
  update() {
   const now = Date.now();
   if (!this.target || now >= this.target) this.target = this.boundary(now);
   const remaining = Math.max(0,Math.ceil((this.target - now) / 1000));
   const values = { hours:Math.floor(remaining / 3600), minutes:Math.floor(remaining / 60) % 60, seconds:remaining % 60 };
   for (const [unit,value] of Object.entries(values)) this.querySelector(`[data-${unit}]`).textContent = String(value).padStart(2,'0');
  }
 }
 customElements.define('mkc-announcement',MkcAnnouncement);
}

  } catch(e) { console.error(e); }
})();
})();
